import React from 'react';
import loader from './loader.gif'; // make sure loader.gif is in same folder
import './preloader.css'; // optional for alignment

const Preloader = () => {
  return (
    <div className="preloader-body">
      <img src={loader} alt="Loading..." className="preloader-img" />
    </div>
  );
};

export default Preloader;
